var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-83c72545.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-26b86ff1.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M1.528 6H30.49c.506 1.088.678 1.909.678 1.909L31.19 8H.837l.03-.125s.167-.803.661-1.875ZM.835 24h30.327l-.029.124s-.168.804-.662 1.876H1.529c-.495-1.072-.663-1.876-.663-1.876L.836 24Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.837 8h30.352c.646 2.729.84 5.519.808 8.016.032 2.456-.193 5.233-.834 7.984H.836c-.672-2.75-.865-5.529-.833-8.017C-.029 13.528.196 10.751.837 8Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16 21.333c-4.356 0-7.467-3.555-9.334-5.333 1.867-1.778 4.978-5.333 9.334-5.333 4.977 0 7.466 3.555 9.333 5.333-1.866 1.778-4.355 5.333-9.333 5.333Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M16 21.333c-4.356 0-7.467-3.555-9.334-5.333 1.708-1.626 4.456-4.74 8.245-5.259.093-.013-.889.952.396 2.398.699.785-1.46 1.8.249 3.335 1.708 1.534-.237 2.096.444 2.987.863 1.129 2.626 1.585 1.493 1.76a9.774 9.774 0 0 1-1.493.112Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagSwz = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagSwz_default = SvgFlagSwz;
export {
  FlagSwz_default as default
};
